module.exports = __webpack_public_path__ + "img/cloudca-black.e617e95a.svg";